<div layout-horizontal layout-align-items-center>
  @if (!value && !avatarPreview) {
    <div layout-horizontal layout-align-items-center>
      @if (type() === InputType.Avatar) {
        <div class="avatar" margin-right-small (click)="fileInput.click()" clickable>
          <rt-icon
            class="person-icon"
            name="person"
            size="medium"
            colorToken="colorIconLowDefault"
          />
        </div>
      }
      @if (type() === InputType.Logo) {
        <div class="logo" margin-right-small (click)="fileInput.click()" clickable>
          <rt-icon name="nav-company" colorToken="colorIconLowDefault" />
        </div>
      }
    </div>
    <div layout-vertical>
      <ng-container [ngTemplateOutlet]="uploadButton" />
      @if (!displayError) {
        <span class="file-details"> {{ translations().fileDetails }}</span>
      } @else {
        <span class="file-details error"> {{ errorMessage }}</span>
      }
    </div>
  }
  @if (value || avatarPreview) {
    <div layout-horizontal>
      @if (type() === InputType.Logo) {
        <img
          class="logo-preview"
          margin-right-small-x
          [src]="$any(avatarPreview)"
          alt="uploaded logo"
        />
      }
      @if (type() === InputType.Avatar) {
        <rt-avatar
          [type]="'image-with-container'"
          [size]="'large'"
          [shape]="'oval'"
          [imageSrc]="$any(avatarPreview)"
          margin-right-small-x
        />
      }
      <div layout-vertical>
        <div layout-horizontal>
          <ng-container [ngTemplateOutlet]="uploadButton" />
          <rt-button
            variant="plain"
            (click)="clearValue(fileInput); $event.preventDefault()"
            margin-left-small
          >
            <rt-icon prefix name="delete-outline" />
            <span>{{ translations().remove }}</span>
          </rt-button>
        </div>
        <div layout-horizontal>
          @if (displayError) {
            <span class="file-details error"> {{ errorMessage }}</span>
          }
        </div>
      </div>
    </div>
  }
  <input #fileInput (change)="onFileChange(fileInput)" type="file" accept="{{ inputAcceptAttr }}" />
</div>

<ng-template #uploadButton>
  <rt-button
    class="upload-button"
    variant="outline"
    (click)="fileInput.click()"
    margin-bottom-small-x
  >
    <rt-icon prefix name="cloud-upload" />
    <span>{{ value ? translations().secondaryCta : translations().cta }}</span>
  </rt-button>
</ng-template>
